module.exports = __webpack_public_path__ + "img/g5.d42524b0.jpeg";